import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment/environment';
import {
  APIuuid,
  IAPIArrayData,
  IAPIData
} from '@shared/interfaces/api.interface';
import { IVerificationRequest } from '@shared/interfaces/verification-request.interface';
import { Experience } from '@shared/models/experience.model';
import { VerificationRequest } from '@shared/models/verification-request.model';
import { Verification } from '@shared/models/verification.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PublicVerificationRequestsService {
  private readonly ENDPOINT_V3: string = String(
    `${environment.ENDPOINTS.BACK_END.V3}/public/verification_requests`
  );

  constructor(private readonly _http: HttpClient) {}

  public get(id: APIuuid): Observable<IVerificationRequest> {
    return this._http
      .get(`${this.ENDPOINT_V3}/${id}`)
      .pipe(map((res: IAPIData) => VerificationRequest.fromAPI(res)));
  }

  public post(id: any, body: any): Observable<IVerificationRequest> {
    const data: IAPIArrayData = {} as IAPIArrayData;
    data.data = body.verifications.map((v: any) => ({
      verifier: new Verification(v.verifier).apiData,
      experience: new Experience(v.experience).apiData
    }));

    return this._http
      .post(`${this.ENDPOINT_V3}`, {
        ...data,
        id
      })
      .pipe(map((res: IAPIData) => VerificationRequest.fromAPI(res)));
  }
}
